import { Alert, Button, Card, Form, Input } from 'antd'
import { Link } from 'react-router-dom'

type SetPasswordFormProps = {
  email?: string | null
  passwordLabel?: string
  submitLabel: string
  onSubmit: (values: { password: string; confirmPassword: string }) => Promise<void>
  loading: boolean
  error: string | null
  backToSignIn?: boolean
}

export default function SetPasswordForm({
  email,
  passwordLabel = 'Password',
  submitLabel,
  onSubmit,
  loading,
  error,
  backToSignIn = true,
}: SetPasswordFormProps) {
  const [form] = Form.useForm<{ password: string; confirmPassword: string }>()

  return (
    <Card className="w-full max-w-md" title={submitLabel === 'Complete signup' ? 'Set your password' : 'Set new password'}>
      {email && (
        <p className="text-gray-600 mb-4">
          {submitLabel === 'Complete signup' ? (
            <>Complete your account for <strong>{email}</strong></>
          ) : (
            <>Enter a new password for <strong>{email}</strong></>
          )}
        </p>
      )}
      {error && <Alert type="error" message={error} className="mb-4" />}
      <Form form={form} layout="vertical" onFinish={(v) => void onSubmit(v)}>
        <Form.Item
          name="password"
          label={passwordLabel}
          rules={[
            { required: true, message: 'Password is required' },
            { min: 8, message: 'Password must be at least 8 characters' },
          ]}
        >
          <Input.Password autoComplete="new-password" size="large" />
        </Form.Item>
        <Form.Item
          name="confirmPassword"
          label="Confirm password"
          dependencies={['password']}
          rules={[
            { required: true, message: 'Please confirm your password' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) return Promise.resolve()
                return Promise.reject(new Error('Passwords do not match'))
              },
            }),
          ]}
        >
          <Input.Password autoComplete="new-password" size="large" />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block size="large">
            {submitLabel}
          </Button>
        </Form.Item>
      </Form>
      {backToSignIn && (
        <p className="text-center text-sm text-gray-500">
          <Link to="/login">Back to sign in</Link>
        </p>
      )}
    </Card>
  )
}
